import { createFileRoute, redirect } from '@tanstack/react-router'

/// The sold passes moved to the section's first page (`/passes`); an old
/// link or bookmark lands there with its filters (`?state=`, `?orders=`).
export const Route = createFileRoute('/_app/c/$orgId/passes/sold')({
  beforeLoad: ({ params, search }) => {
    throw redirect({ to: '/c/$orgId/passes', params, search, replace: true })
  },
})
